import { render } from "./ModalCadastroVencido.vue?vue&type=template&id=0796ccc6&scoped=true"
import script from "./ModalCadastroVencido.vue?vue&type=script&lang=js"
export * from "./ModalCadastroVencido.vue?vue&type=script&lang=js"

import "./ModalCadastroVencido.vue?vue&type=style&index=0&id=0796ccc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0796ccc6"]])

export default __exports__